import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAllLuckyTickets,
  getLuckyTicketsByUserAndTicketNo,
  getLuckyTicketsByDate,
  getLuckyTicketsByDateAndTicketNo,
} from "../../utilities/services/luckyNumber";

// Async actions
export const fetchLuckyTicketsByUserAndTicketNo = createAsyncThunk(
  "luckyNumbers/fetchByUserAndTicketNo",
  async ({ userId, ticketNo }) => {
    const response = await getLuckyTicketsByUserAndTicketNo(userId, ticketNo);
    return response.data;
  }
);

export const fetchLuckyTicketsByDateAndTicketNo = createAsyncThunk(
  "luckyNumbers/fetchByDate",
  async ({ start_date, end_date, ticketNo }) => {
    const response = await getLuckyTicketsByDateAndTicketNo(
      start_date,
      end_date,
      ticketNo
    );
    return response.data;
  }
);

export const fetchLuckyTicketsByDate = createAsyncThunk(
  "luckyNumbers/fetchByDateAndTicketNo",
  async ({ start_date, end_date }) => {
    const response = await getLuckyTicketsByDate(start_date, end_date);
    return response.data;
  }
);

export const fetchAllLuckyTickets = createAsyncThunk(
  "luckyNumbers/fetchAll",
  async () => {
    const response = await getAllLuckyTickets();
    console.log("asdacds", response.data);
    return response.data;
  }
);

const luckyNumberSlice = createSlice({
  name: "luckyNumbers",
  initialState: {
    luckyNumbers: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLuckyTicketsByUserAndTicketNo.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        fetchLuckyTicketsByUserAndTicketNo.fulfilled,
        (state, action) => {
          state.loading = false;
          state.luckyNumbers = action.payload;
        }
      )
      .addCase(fetchLuckyTicketsByUserAndTicketNo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchLuckyTicketsByDate.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLuckyTicketsByDate.fulfilled, (state, action) => {
        state.loading = false;
        state.luckyNumbers = action.payload;
      })
      .addCase(fetchLuckyTicketsByDate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchLuckyTicketsByDateAndTicketNo.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        fetchLuckyTicketsByDateAndTicketNo.fulfilled,
        (state, action) => {
          state.loading = false;
          state.luckyNumbers = action.payload;
        }
      )
      .addCase(fetchLuckyTicketsByDateAndTicketNo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchAllLuckyTickets.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllLuckyTickets.fulfilled, (state, action) => {
        state.loading = false;
        state.luckyNumbers = action.payload;
      })
      .addCase(fetchAllLuckyTickets.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default luckyNumberSlice.reducer;
